// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"36e7e150","453":"fe59cd43","732":"d5f58b23","977":"0d079411"}[chunkId] + ".chunk.js";
};